
export default function clearRadioButtonSelection () {
  const ele = document.getElementsByName('selectedChoice')
  for (let i = 0; i < ele.length; i++) {
    ele[i].checked = false
  }
}
